export default {
  fields: {
    online_shop_domain: 'Domínio próprio para a loja online',
    online_shop_domain_hint:
      'Um domínio do restaurante, por exemplo order.pizzeria-mario.com — apenas para encomendas; um website precisa de outro. Depois de guardado, os registos a adicionar aparecem aqui.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
